import React from 'react';
import { Link } from "react-router-dom";
import Wallet from './wallet';

const Navbar = () => (
  <div>
      <p className='logo'>
        <Link to="/" className='home-link'>blockfact</Link>
        <Link to="/admin" className='admin-link'>*</Link>
      </p>
      <div className='navbar-wallet'>
        <Wallet></Wallet>
      </div>
      <div className='clear'></div>
  </div>
);

export default Navbar;